import React from 'react';
import { BasicCollapse } from 'ui-lib';
import { IConfigureStepProps } from '../component-version-wizard.types';
import { DockerImagesPickerFormItem } from '../../docker-images-picker';
import { ArtifactsPickerFormItem } from '../../artifacts-picker';
import css from '../../raptor-components.css';

export const DockerFileConfigureStep = (props: IConfigureStepProps): JSX.Element => {
    return (
        <BasicCollapse
            className={css['manifest-panel']}
            key={props.selectedPlatforms.map((platform) => platform.uuid).join('|')}
            defaultActiveKey={props.selectedPlatforms.map((platform) => platform.uuid)}
            panels={props.selectedPlatforms.map((platform) => ({
                key: platform.uuid,
                header: platform.displayName,
                content: (
                    <React.Fragment>
                        <ArtifactsPickerFormItem
                            name={['manifests', platform.uuid, 'uploadedFiles']}
                            label='Artifact'
                            selectionType='single'
                            isRequired={true}
                            accountUuid={props.accountUuid}
                            source={props.artifactsSource}
                        />
                        <DockerImagesPickerFormItem
                            name={['manifests', platform.uuid, 'dockerImages']}
                            label='Docker Image'
                            selectionType='single'
                            isRequired={true}
                            source={props.dockerImagesSource}
                        />
                    </React.Fragment>
                ),
            }))}
        />
    );
};
